import './styles.css';

import React, { useEffect } from 'react';
import ShowShelves from './ShowShelves';
import { connect } from 'react-redux';
import { fetchShows } from 'actionCreators/cast';
import { IShow } from 'interface/cast';

interface IProps {
  shows: IShow[];
  fetchShows: () => void;
}

const NutrorCast = ({ shows, fetchShows }: IProps) => {
  useEffect(() => {
    fetchShows();
    // eslint-disable-next-line
  }, []);

  if (!shows?.length) {
    return null;
  }

  return (
    <div className='nc-root'>
      <label>
        Nutror<span>Cast</span>
      </label>
      <ShowShelves shows={shows} />
    </div>
  );
};

const mapStateToProps = (state: any) => ({
  shows: state.cast.data,
});

export default connect(mapStateToProps, { fetchShows })(NutrorCast);
